import { useState, useEffect } from 'react';
import { useApi, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import type { QltyTreemapNode } from '../qlty.api.types';

export function useQltyTreemap(entityRef: string) {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<QltyTreemapNode[]>([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const baseUrl = await discoveryApi.getBaseUrl('qlty');
        const encoded = encodeURIComponent(entityRef);
        const res = await fetchApi.fetch(`${baseUrl}/${encoded}/dashboard/treemap`);
        if (cancelled) return;
        if (res.ok) {
          setData(await res.json());
        } else {
          setError(`Failed to load treemap (${res.status})`);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load treemap');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [entityRef, discoveryApi, fetchApi]);

  return { loading, error, data };
}
